import { apiClient } from '@repo/shared';

const getVacationDates = async () => {
  const vacationDates = await apiClient.get("/api/config/vacation");
  return vacationDates;
};

const getVacationDatesForYear = async (year) => {
  const vacationDates = await apiClient.get(`/api/config/vacation?year=${year}`);
  return vacationDates;
};

const getUnpaidSpecialEventEmailBody = async (year) => {
  const unpaidEmailBody = await apiClient.get(`/api/config/unpaidSpecialEventEmail`);
  return unpaidEmailBody;
};

const getUnpaidEmailBody = async (year) => {
  const unpaidEmailBody = await apiClient.get(`/api/config/unpaidEmail`);
  return unpaidEmailBody;
};

const saveVacationDateRow = async(vacationDateRow) => {
  var returnVacationDates;
  if (vacationDateRow.id.startsWith('t')) {
    //It's a new vacation date row
    returnVacationDates = await apiClient.post(`/api/config/vacation`, vacationDateRow);
  } else {
    //Updating an existing theme
    console.log('saving theme', vacationDateRow);
    returnVacationDates = await apiClient.post(`/api/config/vacation/${vacationDateRow.id}`, vacationDateRow);
  }
  return returnVacationDates;
};

const getSemesterDates = async () => {
  const vacationDates = await apiClient.get("/api/config/semester");
  return vacationDates;
};

const getSemesterDatesForYear = async (year) => {
  const semesterDates = await apiClient.get(`/api/config/semester?year=${year}`);
  return semesterDates?.[0];
};

const saveSemesterDatesForYear = async(semesterDatesForYear) => {
  const returnSemesterDates = await apiClient.post(`/api/config/semester`, semesterDatesForYear);
  return returnSemesterDates;
}

const deleteVacationDateRow = async(id) => {
  const returnVacationDates = await apiClient.delete(`/api/config/vacation/${id}`);
  return returnVacationDates;
};

const sendEmail = async(toAddresses, subject, body) => {
  const emailSent = await apiClient.post(`/api/email`, {
    toAddresses,
    subject,
    body
  });
  return emailSent;
}

const getEmailConfig = async() => {
  const emailConfig = await apiClient.get(`/api/config/email`);
  return emailConfig;
};

const saveEmailConfig = async(emailConfig) => {
  const savedConfig = await apiClient.post(`/api/config/email`, emailConfig);
  return savedConfig;
};

const getEmailTemplates = async() => {
  const emailTemplates = await apiClient.get(`/api/config/emailTemplates`);
  console.log('fetched email templates', emailTemplates);
  return emailTemplates;
};

const saveEmailTemplate = async(emailTemplate) => {
  const savedTemplate = await apiClient.post(`/api/config/emailTemplates`, emailTemplate);
  return savedTemplate;
};

const getAllConfig = async() => {
  const allConfig = await apiClient.get(`/api/config`);
  return allConfig;
};

const getConfigByType = async(type) => {
  const configByType = await apiClient.get(`/api/config?type=${type}`);
  return configByType;
};

const saveConfigItem = async(configItem) => {
  const savedItem = await apiClient.post(`/api/config/${configItem.id}`, configItem);
  return savedItem;
};

const getConfigByTypeAndName = async(type, name) => {
  console.log('fetching config by type', type, 'and name', name);
  const configByType = await apiClient.get(`/api/config/${type}/${name}`, {});
  return configByType;
};

const getActiveYearAndSemesterFromSemesterDates = async(semesterDates) => {
  if (!semesterDates || semesterDates.length === 0) {
    semesterDates = await getSemesterDates();
  }
  //find the active semester
  //if current date is > activeYear.summerDate then the active semester is Summer, otherwise WInter
  const activeYear = semesterDates.find(date => date.active)
  const currentDate = new Date();
  const activeSemester = (activeYear && currentDate > new Date(activeYear.summerDate)) ? 'Summer' : 'Winter';
  return { activeYear, activeSemester };
};

const getTutorials = async() => {
  const tutorials = await apiClient.get(`/api/tutorial`);
  return tutorials;
};

const ConfigService = {
  getVacationDates,
  getVacationDatesForYear,
  saveVacationDateRow,
  deleteVacationDateRow,
  saveSemesterDatesForYear,
  getSemesterDates,
  getSemesterDatesForYear,
  getUnpaidEmailBody,
  getUnpaidSpecialEventEmailBody,
  sendEmail,
  getEmailConfig,
  saveEmailConfig,
  getEmailTemplates,
  saveEmailTemplate,
  getAllConfig,
  getConfigByType,
  saveConfigItem,
  getConfigByTypeAndName,
  getActiveYearAndSemesterFromSemesterDates,
  getTutorials
};

export default ConfigService;